/**
 * Write-mode boundary acknowledgment for Engine Editor surface. Per
 * scope-doc §2 lines 192-196 — write-altitude reader-orientation that
 * primes admins for the negative-affordance vocabulary they'll encounter
 * across cells before encountering it.
 *
 * Rendered in title section directly below engine/scenario BoundaryNote
 * per scope-doc §2 line 187 order (engine/scenario first, write-mode
 * second). Style mirrors Atlas BoundaryNote (text-xs text-ink-muted
 * italic) for legend-altitude visual consistency between the two notes.
 *
 * No substrate dependency — static copy. Admin-trust-signal at
 * surface-entry altitude.
 */

import type { JSX } from 'react';

export default function EngineEditorWriteModeBoundaryNote(): JSX.Element {
  return (
    <p className="text-xs text-ink-muted italic">
      Edit affordances calibrate per substrate-shape. Some configuration values
      aren&apos;t editable from here — Algopix-sourced values update via import;
      system-managed values cascade from triggered events; code-level values
      change via deployment. Where you can&apos;t edit from here, the surface
      tells you where the value comes from.
    </p>
  );
}
